export const INIT_PARAM = "INIT_PARAM:";
